export default '4.73.3';
